import { FC, ReactElement } from 'react';

import { EvBodyMedium, EvFlexRow, HeadingLevelRange, TEXT_COLOR } from '@evinced-private/ui-common';

import {
	TEXT_BLOCK_WITH_TITLE_DAID,
	TEXT_BLOCK_WITH_TITLE_VALUE_DAID
} from 'data-automation-ids/data-automation-ids';

interface ITextBlockWithTitleProps {
	name: string;
	value: ReactElement | string;
	headingLevel?: HeadingLevelRange;
	dataAutomationId?: string;
}

export const TextBlockWithTitle: FC<ITextBlockWithTitleProps> = ({
	name,
	value,
	headingLevel = 4,
	dataAutomationId = TEXT_BLOCK_WITH_TITLE_DAID
}) => {
	if (!value) {
		return null;
	}

	return (
		<EvFlexRow align="CENTER" gap="MEDIUM" dataAutomationId={dataAutomationId}>
			<EvBodyMedium as={`h${headingLevel}`} color={TEXT_COLOR.CONTENT_3}>
				{name}
			</EvBodyMedium>
			<EvBodyMedium
				dataAutomationId={TEXT_BLOCK_WITH_TITLE_VALUE_DAID}
				color={TEXT_COLOR.CONTENT_1}
			>
				{value}
			</EvBodyMedium>
		</EvFlexRow>
	);
};
